import React from 'react';
import PropTypes from 'prop-types';
import FilterButton from './FilterButton';
import { toggleItemInArray } from '../../lib/Utils';
import './FilterMobile.scss';

class FilterMobile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: Array.from(props.selected),
    };

    // Bind event handlers
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.handleApplyClick = this.handleApplyClick.bind(this);
    this.handleToggleClick = this.handleToggleClick.bind(this);
    this.handleFilterSelect = this.handleFilterSelect.bind(this);
    this.haveFiltersChanged = this.haveFiltersChanged.bind(this);
  }

  componentWillReceiveProps(newProps, oldProps) {
    // If selected filters have changed, then reset local state to the state from props.
    if (newProps.selected !== oldProps.selected) {
      this.setState({
        selected: newProps.selected,
      });
    }
  }

  handleFilterSelect(filter) {
    this.setState({
      selected: toggleItemInArray(this.state.selected, filter),
    });
  }

  haveFiltersChanged() {
    const { selected: mobileFilters } = this.state;
    const { selected: storeFilters } = this.props;

    if (mobileFilters.length !== storeFilters.length) return true;
    if (storeFilters.length === 0 && mobileFilters.length === 0) return false;

    return !mobileFilters.every(item => storeFilters.includes(item));
  }

  handleToggleClick() {
    this.props.toggleVisibility(false);
  }

  handleCancelClick(e) {
    if (e.keyCode && e.keyCode !== 27) return;

    this.setState({
      selected: this.props.selected,
    });

    this.props.toggleVisibility(false);
  }

  handleApplyClick() {
    if (this.haveFiltersChanged()) {
      this.props.handleFilterChange(this.state.selected);
      this.props.toggleVisibility(false);
    }
  }

  render() {
    const { selected } = this.state;
    const { visible } = this.props;

    return (
      <section className={`filter filter--mobile ${!visible ? '' : 'filter--full_screen'}`}>
        <div
          role="presentation"
          className="filter-overlay"
          onClick={this.handleCancelClick}
          onKeyUp={this.handleCancelClick}
        />
        <div className="filter-drawer">
          <ul className="filter-items">
            {this.props.filters.map(item => (
              <li className="filter-item" key={`mobile-${item.type}`}>
                <FilterButton
                  key={item.type}
                  {...item}
                  handleClick={this.handleFilterSelect}
                  selected={selected.includes(item.type)}
                />
              </li>
            ))}
          </ul>
          <div className="btn_group">
            <button
              className="btn btn--icon"
              onClick={this.handleCancelClick}
              aria-label="button cancel"
            >
              <i className="icon icon--cancel" />
              {this.props.cancelButtonText}
            </button>
            <button
              className="btn btn--icon"
              onClick={this.handleApplyClick}
              disabled={!this.haveFiltersChanged() ? 'disabled' : ''}
              aria-label="button apply"
            >
              <i className="icon icon--apply" />
              {this.props.applyButtonText}
            </button>
          </div>
        </div>
      </section>
    );
  }
}

FilterMobile.propTypes = {
  filterLabel: PropTypes.string.isRequired,
  selected: PropTypes.arrayOf(PropTypes.string).isRequired,
  filters: PropTypes.arrayOf(PropTypes.object).isRequired,
  cancelButtonText: PropTypes.string.isRequired,
  applyButtonText: PropTypes.string.isRequired,
  toggleVisibility: PropTypes.func.isRequired,
  handleFilterChange: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default FilterMobile;
